import * as React from 'react';
export const icbSvg = React.forwardRef(function icbSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E3002B',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M23.1 6.58H8.9A2.32 2.32 0 0 0 6.58 8.9v14.2a2.32 2.32 0 0 0 2.32 2.32h14.2a2.32 2.32 0 0 0 2.32-2.32V8.9a2.32 2.32 0 0 0-2.32-2.32ZM8.9 6A2.9 2.9 0 0 0 6 8.9v14.2A2.9 2.9 0 0 0 8.9 26h14.2a2.9 2.9 0 0 0 2.9-2.9V8.9A2.9 2.9 0 0 0 23.1 6H8.9Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm10.898 8.655-1.74 2.75-.067 1.682 1.122 2.254 2.054.812.809 1.251 1.055.181.875.946.685-.067.247-.745.999-.879 1.179-.124.998.497.314.879.619.687.56-.067.372-.811v-.745l-.438-1.5 1.065-1.251-.066-1.5L22.843 9.4h-1.237l-1.493 1.624H19.8l-.56.19v-1.25h-2.797l-2.739-.44-2.805-.869Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm10.337 16.029 1.683.687.808 1.252 1.123.181.931.879.809-.067.247 1.881.628.306.304-.057.751-.879.999.191.057 1.433-1.617.687L15.5 23.9l-2.548-1.06.066-.497-1.188-2.436-.305.688-.998.057-.561-2.56.37-2.062Z',
      fill: '#fff',
    }),
  );
});
icbSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var icb = {
  category: 'brand',
  colorable: false,
  name: 'icb',
  svg: icbSvg,
};
